import { OnInit, ElementRef, AfterViewInit, ChangeDetectorRef, EventEmitter, OnChanges } from '@angular/core';
import * as pickadate from 'pickadate';
import { isChildOf } from '../../../utilities/html.utilities';
var DatepickerComponent = /** @class */ (function () {
    function DatepickerComponent(changeDetectorRef) {
        this.changeDetectorRef = changeDetectorRef;
        this.date = new Date();
        this.dateChanged = new EventEmitter();
        this.visible = false;
    }
    DatepickerComponent.prototype.ngOnInit = function () {
    };
    DatepickerComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.picker = pickadate.create({
            selected: this.date
        });
        this.datepicker.nativeElement.addEventListener('pickadate:change', function () {
            _this.date = new Date(_this.picker.getValue());
            _this.changeDetectorRef.detectChanges();
            _this.dateChanged.emit(_this.date);
        });
        pickadate.render(this.datepicker.nativeElement, this.picker);
        this.datepicker.nativeElement.remove();
    };
    DatepickerComponent.prototype.ngOnChanges = function () {
        if (!this.picker) {
            return;
        }
        this.picker.setSelected({
            value: this.date
        });
    };
    DatepickerComponent.prototype.toggle = function (e) {
        if (e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
        this.visible = !this.visible;
        if (this.visible) {
            this.wrapper.nativeElement.appendChild(this.datepicker.nativeElement);
        }
        else {
            this.datepicker.nativeElement.remove();
        }
    };
    DatepickerComponent.prototype.onClick = function (target) {
        if (!this.visible) {
            return;
        }
        if (target !== this.datepicker.nativeElement && !isChildOf(this.datepicker.nativeElement, target)) {
            this.toggle();
        }
    };
    Object.defineProperty(DatepickerComponent.prototype, "day", {
        get: function () {
            if (!this.date) {
                return;
            }
            return this.date.getDate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatepickerComponent.prototype, "dayString", {
        get: function () {
            switch (this.date.getDay()) {
                case 0:
                    return 'sunday';
                case 1:
                    return 'monday';
                case 2:
                    return 'tuesday';
                case 3:
                    return 'wednesday';
                case 4:
                    return 'thursday';
                case 5:
                    return 'friday';
                case 6:
                    return 'saturday';
            }
        },
        enumerable: true,
        configurable: true
    });
    return DatepickerComponent;
}());
export { DatepickerComponent };
